<template>
  <vue-final-modal
    name="image-viewer-modal"
    :value="isOpen"
    :classes="['image-viewer-modal-container']"
    overlay-class="image-viewer-modal-overlay"
    content-class="image-viewer-modal-content bg-light"
    :lock-scroll="true"
    :hide-overlay="true"
    :click-to-close="false"
    :esc-to-close="false"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="true"
    :resize="true"
    :min-width="400"
    :min-height="600"
    :max-width="Infinity"
    :max-height="Infinity"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :keep-changed-style="true"
    @opened="calcuateViewerSize(false)"
    @resize:move="calcuateViewerSize(true)"
    @resize:end="calcuateViewerSize(false)"
  >
    <div ref="imageViewerModalBody" class="image-viewer-modal-content--body">
      <InlineImageViewer
        v-if="isOpen"
        v-bind="imageViewerProps"
        :viewerWidth="`${viewerWidth}px`"
        :viewerHeight="`${viewerHeight}px`"
        :resizing="resizing"
        @close="handleClose"
      />
    </div>
  </vue-final-modal>
</template>

<script>
/* eslint-disable */
import { EventBus } from "../events/eventBus";
import InlineImageViewer from "./InlineImageViewer";

export default {
  name: "ImageModalContainer",
  components: { InlineImageViewer },
  data() {
    return {
      isOpen: false,
      imageViewerProps: null,
      dragSelector: ".image-viewer-modal-content--header",
      viewerWidth: 800,
      viewerHeight: 600,
      resizing: false,
    };
  },
  created() {
    EventBus.$on("openImageViewerModal", (props) => {
      if (!this.isOpen) {
        this.isOpen = true;
        this.imageViewerProps = props;
      }
    });
    EventBus.$on("closeImageViewerModal", () => {
      this.isOpen = false;
    });
  },
  methods: {
    handleClose() {
      this.isOpen = false;
    },
    calcuateViewerSize(resizing) {
      this.resizing = resizing;

      const $ = window.$;
      const viewerWidth = $(".image-viewer-modal-content").width();
      const viewerHeight = $(".image-viewer-modal-content").height();
      this.viewerWidth = viewerWidth;
      this.viewerHeight = viewerHeight;
    }
  },
  watch: {
    "$route.path": {
      handler(newRoute, oldRoute) {
        if (newRoute !== oldRoute && this.isOpen) {
          this.isOpen = false;
        }
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("openImageViewerModal");
    EventBus.$off("closeImageViewerModal");
  },
};
</script>

<style lang="scss">
.image-viewer-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .image-viewer-modal-content {
    display: grid;
    grid-template-rows: 2rem 1fr;
    border-radius: 5px;
    min-height: 600px;
    box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.15);
  }
}
</style>